/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
const $body = $(document.body);

theme.textColumnsWithImagesCarousel = function() {
  const carousels = $('.js-home-inline-carousel');
  const carouselObserver = generateFireOnViewObserver(theme.textColumnsWithImagesCarouselInit);

  carousels.each(function() {
    const carousel = this;

    if (carouselObserver && !Shopify.designMode) {
        carouselObserver.observe(carousel);
    } else {
        theme.textColumnsWithImagesCarouselInit(carousel);
    }
  });
}

theme.textColumnsWithImagesCarouselInit = function(carouselElement) {
  theme.textColumnsWithImagesCarouselUpdate(carouselElement);
  $(window).on('resize', function() {
  	theme.textColumnsWithImagesCarouselUpdate(carouselElement);
  });
};

theme.textColumnsWithImagesCarouselUpdate = function(carouselElement) {
  const carousel = $(carouselElement);

  function initCarousel(carouselElement) {
  	carouselElement.not(".slick-initialized").slick({
  	  slidesToShow: 1,
  	  slidesToScroll: 1,
  	  arrows: false,
  	  dots: true,
  	  fade: false,
  	  adaptiveHeight: false,
  	  speed: 300,
  	  cssEase: "ease",
  	  lazyLoad: "progressive"
  	});
  }

  if ($(window).width() < theme.mobileBrkp) {
    initCarousel(carousel);
  } else {
    if (carousel.hasClass('slick-initialized')) {
      carousel.slick('unslick');
    }
  }
};

function datalayerUpdates() {
  let itemToBeRemoved;

  // Add to cart event
  $('body').on('afterAddItem.datalayer', function(evt, line_item, form) {
    datalayerAddToCart(line_item, form);
  });
}

/**
 * Locks or unlocks the body scroll depending on a flag. Uses the tua-body-scroll-lock library
 * https://github.com/tuax/tua-body-scroll-lock
 *
 * @param {Boolean} lock Flag to know if we should lock or unlock the body scroll
 * @param {Element} targetElement The target element that will keep the scroll after the lock
 */
function lockOrUnlockBodyScroll(lock, targetElement) {
  if (lock) {
    bodyScrollLock.lock(targetElement);
  } else {
    bodyScrollLock.unlock(targetElement);
  }
}

/**
 * Function that toggles the PLP filters sidebar. It gets the filters element and the inner wrapper to add an 'active' class to the
 * filters and then lock the body scroll with the exception of the wrapper that needs to be scrollable.
 */
function toggleMobileFilters() {
  const wrapper = document.querySelector('.collection-sidebar__wrapper');
  const filters = document.querySelector('.collection-filters');

  if (filters && wrapper) {
    filters.classList.toggle('active');

    const lockBodyScroll = filters.classList.contains('active');

    lockOrUnlockBodyScroll(lockBodyScroll, wrapper);
  }
}

/**
 * Function that listen the click events on the mobile filters button (to open the filters sidebar) and the sidebar close button
 * (to close it).
 *
 * @returns
 */
function handleMobileFilters() {
  const toggleBtn = document.querySelector('.collection-main__filter-btn');
  const closeBtn = document.querySelector('.collection-sidebar__close');

  if (!toggleBtn || !closeBtn) {
    return;
  }

  toggleBtn.addEventListener('click', () => {
    toggleMobileFilters();
  });
  closeBtn.addEventListener('click', () => {
    toggleMobileFilters();
  });
}

/**
 * Function that adds or removes a tag from a current selected tags array. This is because we need to have an array of selected tags
 * for product filtering. If the user is filtering by a specific tag we need to add it to the array and if not, we need to remove it
 *
 * @param {Array} selectedTags The array of current selected tags (filters)
 * @param {String} tag The tag to add or remove from the current selected tags
 * @param {Boolean} add Flag to know if we should add or remove the tag from the current selected tags
 * @returns {Array} A modified array with the current selected tags
 */
function setOrRemoveSelectedTag(selectedTags, tag, add) {
  return add ? selectedTags.concat([tag]) : selectedTags.filter((selectedTag) => selectedTag !== tag);
}

/**
 * Function that initializes the variant select inputs for all product cards. For each product card we get the product id and call
 * the function that initializes the variant select inputs.
 *
 * @param {String} sectionId The id of the current Shopify product grid section
 */
function initProductGridItemSelectOptions(sectionId) {
  const productItems = document.querySelectorAll('.js-product-card');

  [...productItems].forEach((productItem) => {
    const productId = productItem.dataset.productId;

    if (productId && sectionId) {
      theme.productSelect(productId.toString(), sectionId.toString(), 'card', false);
    }
  });
}

/**
 * Function that filters the PLP product grid based on the current selected tags. We structure the URL based on the which tags
 * (filters) are currently selected and then use the Shopify Section API to fetch the product grid section, the API returns
 * the new filtered product grid HTML which we append to the current HTML. After that, we change the URL with the current tags
 * and re-initialize elements of each product card including cleaning all body scroll locks since every time the user filters
 * the PLP on mobile, the filters mobile sidebar closes.
 *
 * @param {Element} collectionSection
 * @param {String} currentCollection
 * @param {Array} selectedTags
 */
async function filterCollection(collectionSection, currentCollection, selectedTags) {
  const sectionId = collectionSection.dataset.sectionId;
  const sectionWrapper = document.getElementById(`shopify-section-${sectionId}`);
  const url = new URL(location.href);
  const searchParams = new URLSearchParams(url.search);
  searchParams.delete("filter.p.tag");
  searchParams.delete("page");

  for (const tag of selectedTags) {
    searchParams.append("filter.p.tag", tag);
  }
  const updatedUrl = url.origin + url.pathname + "?" + searchParams.toString();

  searchParams.append("section_id", sectionId);
  const filterUrl = url.origin + url.pathname + "?" + searchParams.toString();

  try {
    const response = await fetch(filterUrl);
    const filteredProducts = await response.text();

    sectionWrapper.innerHTML = filteredProducts;

    window.history.pushState({}, '', updatedUrl);
    window.dispatchEvent(new CustomEvent('custom::collectionsFiltered'));

    // Since we are overwriting the HTML content we need to reset some listeners
    placeQuickShopForm();
    initProductGridItemSelectOptions(sectionId);
    theme.animScroll();
    theme.accordion();
    theme.collectionFormSubmit();
    theme.quickShopModal();
    bodyScrollLock.clearBodyLocks();
  } catch (error) {
    console.error(error);
  }
}

/**
 * Function that triggers a PLP filtering (both desktop and mobile) when the submit button is clicked. First we get
 * the current selected tags from the URL and then we listen for the change event on the submit button with the current
 * selected tags. For each of these we get the tag (filter) we want to add/remove and call the filterCollection function.
 *
 * @returns
 */
function handleCollectionFilters() {
  const collectionSection = document.querySelector('[data-collection]');

  if (!collectionSection) {
    return;
  }

  handleMobileFilters();

  const currentCollection = collectionSection.dataset.collection;
  const formSubmitButton = document.querySelector(".collection-sidebar__submit-button");
  const selectedTagsButtons = document.querySelectorAll('.collection__filters-active__tag');
  const url = new URL(location.href);
  const params = new URLSearchParams(url.search);
  let selectedTags = params.getAll("filter.p.tag");

  formSubmitButton.addEventListener('click', (evt) => {
    const filter = evt.target;
    selectedTags = setOrRemoveSelectedTag(selectedTags, filter.value, filter.checked);

    filterCollection(collectionSection, currentCollection, selectedTags);
  });

  [...selectedTagsButtons].forEach((btn) => {
    btn.addEventListener('click', (evt) => {
      const filter = evt.target;
      selectedTags = setOrRemoveSelectedTag(selectedTags, filter.dataset.value, false);

      filterCollection(collectionSection, currentCollection, selectedTags);
    });
  });
}

/**
 * Function that places the quickshop's 'Add to cart' form in the proper place according to the screen size. For each product card
 * we get the form and append it to the proper wrapper depending on the screen size. This is required because we can't render the
 * same 'Add to cart' form in 2 different places in the same product card, this is a limitation of this theme (see vendor.js
 * Shopify.OptionSelectors function, this method does a querySelector on the js-product-form class, not allowing for multiple forms)
 */
function placeQuickShopForm() {
  const productItems = document.querySelectorAll('.js-product-card');

  [...productItems].forEach((productItem) => {
    const form = productItem.querySelector('.js-product-form');

    if (!form) {
      return;
    }

    const parentClass = window.screen.width < theme.tabletBrkp ? '.product-card__form-mobile' : '.product-card__form-desktop';
    const parent = productItem.querySelector(parentClass);

    if (parent && form) {
      parent.appendChild(form);
    }
  });
}

function handlePDPRechargeModal() {
  const triggerer = document.querySelector('.product-single__recharge-modal-trigger');

  if (!triggerer) {
    return;
  }

  triggerer.addEventListener('click', () => {
    const closeIcon = '<button title="Close (Esc)" type="button" class="mfp-close mfp-close--custom js-close-mfp" aria-label="close"><i class="icon icon--close"></i></button>';
    const closeButton = document.querySelector('.product-single__recharge-modal-close');

    $.magnificPopup.open({
      items: {
        src: '.product-single__recharge-modal-wrapper'
      },
      type: 'inline',
      mainClass: 'mfp-medium',
      fixedContentPos: true,
      midClick: true,
      closeMarkup: closeIcon,
      removalDelay: 200,
      callbacks: {
        open: function () {
          closeButton.addEventListener('click', $.magnificPopup.close);
        }
      }
    })
  });
}

const PressLoadMore = (function ($) {
  let $moreTrigger;
  let $articles;
  let articlesTotal;
  let articlesPerLoad = 12;
  let articleLimit = articlesPerLoad;

  function init(el) {
    $moreTrigger = $(el);
    $articles= $('.js-press-item');
    articlesTotal = $articles.length;

    bindEvents();
  }

  function bindEvents() {
    // Expand or collapse group of buttons
    $moreTrigger.on('click', function() {
      increaseLimit();
      showMoreArticles();
      updateButtonStatus();
    });
  }

  function increaseLimit() {
    articleLimit = articleLimit + articlesPerLoad;
  }

  function showMoreArticles() {
    $articles.each(function(index) {
      index++; //add one to make count not zero-based

      if ( index <= articleLimit ) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  }

  function updateButtonStatus() {
    if ( articleLimit >= articlesTotal ) {
      $moreTrigger.hide();
    }
  }

  return init;

}) (jQuery);

function loadMoreArticles() {
  const $pressLoadMore = $('.js-load-more-articles');

  if ($pressLoadMore) {
    $pressLoadMore.each(function() {
      new PressLoadMore(this);
    });
  }
}

window.addEventListener('DOMContentLoaded', () => {
  datalayerUpdates();
  handleCollectionFilters();
  placeQuickShopForm();
  handlePDPRechargeModal();
  loadMoreArticles();

  window.addEventListener('custom::collectionsFiltered', handleCollectionFilters);
  window.addEventListener('resize', () => {
    placeQuickShopForm();
  });
});

theme.textColumnsWithImagesCarousel();

/*
 A11Y Fixes
*/

$(window).on("load", function () {
  // Update sidecart product count inside of an aria label
  const observer = new MutationObserver(() => $('#CartCount') ? $('.js-cart-trigger').attr('aria-label', `${$('#CartCount').html()} Products in Cart`) : '');
  observer.observe($('#CartCount')[0], { characterData: true, childList: true });
  // Set 'Buy Online/Locally' section in product template to W3C pattern for tabs/tabpanel
  $('.tablinks').on('keydown', function(e) {
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      $(this).attr('tabindex', -1).next('.tablinks').attr('tabindex', 0).focus();
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      $(this).attr('tabindex', -1).prev('.tablinks').attr('tabindex', 0).focus();
    }
  });
  $('.tablinks').on('click', function () {
    $('.tablinks').attr('aria-selected', 'false');
    $(this).attr('aria-selected', 'true');
  });
  /*
    Trigger alt image on product images via a hidden button for screen readers
    And read alt text for currently shown image
  */
  $(document).on('click', '.change-product-image', function (e) {
    e.preventDefault();
    let productCardImagesContainer = $(this).closest('.product-card__details').prev();
    let productCardImages = productCardImagesContainer.find('img');
    let ariaLiveElement = $('.aria-change-product-image');

    productCardImagesContainer.find('.product-card__img-hover').toggleClass('opacity no-opacity');
    productCardImagesContainer.find('.product-card__img').toggleClass('opacity no-opacity');

    let currentProductCardImage = productCardImagesContainer.find('img.opacity');
    ariaLiveElement.text(`Changed image to ${currentProductCardImage.index()} of ${productCardImages.length}, ${currentProductCardImage.attr('alt')}`);
  });
  $(document).on("focusin", '.product-card__details', function() {
    $(this).find('.change-product-image').removeClass('visually-hidden');
    $(this).find('.product-card__form-desktop--focus').removeClass('visually-hidden');
  });
  $(document).on("focusout", '.product-card__details', function() {
    $(this).find('.change-product-image').addClass('visually-hidden');
    $(this).find('.product-card__form-desktop--focus').addClass('visually-hidden');
  });
  // Synchronizes alternate product image by changing classes on mouseenter and mouseleave
  $(document).on("mouseenter mouseleave", ".product-card-top", function () {
    $(this).css('visibility', (_, visibility) => visibility === 'visible' ? 'hidden' : 'visible');
    $(this).find('.product-card__img-hover').toggleClass('opacity no-opacity');
    $(this).find('.product-card__img').toggleClass('opacity no-opacity');
  });
  function toggleAriaExpanded(element) {
    let expanded = $(element).attr("aria-expanded") === "true";
    $(element).attr("aria-expanded", !expanded);
  }
  $(".primary-nav__link--modal-icon").on('click', function() {
    toggleAriaExpanded(this);
  });
  $('#add-address--accordion').on('click', function() {
    toggleAriaExpanded(this);
  });
  $(".account__address-actions a:first-of-type").on('click', function() {
    toggleAriaExpanded(this);
  });
  $(".account__address-actions a:first-of-type").attr({
    "aria-expanded": false
  });
  $(".account__address-actions a").attr({
    "role": "button"
  });
  $(document).on("click", ".best-seller__product-list-arrows > button", function () {
    $('.product-card-top').css('visibility', 'visible');
  });
});

/**
 * Waits for the specified element to be present in the document and returns a promise.
 * @param {string} selector - A valid CSS selector for the target element.
 * @returns {Promise<Element>} - A promise that resolves to the target element.
 */
async function isElementLoaded(selector) {
  while (document.querySelector(selector) === null) {
    await new Promise((resolve) => requestAnimationFrame(resolve));
  }
  return document.querySelector(selector);
}

/**
  * Update the validation UI state for a given input element.
  * @param {HTMLInputElement} inputEl The input element to update the UI state for.
  */
const updateValidationState = (inputEl) => {
  const isInputValid = inputEl.checkValidity();

  if (!inputEl.required && inputEl.value === '' && isInputValid) {
    inputEl.classList.remove('is-invalid')
  } else {
    inputEl.classList.toggle('is-invalid', !isInputValid);
    inputEl.setAttribute('aria-invalid', (!isInputValid).toString());
  }

  const errorEl = inputEl.nextElementSibling;
  errorEl.textContent = inputEl.validationMessage;
  errorEl.hidden = isInputValid;
}

/**
 * Handler for a form submit event.
 * @param {SubmitEvent} event The submit event object that triggered the submit event.
 */
const onSubmit = (event) => {
  document.querySelectorAll('.js-validate').forEach(updateValidationState);

  const formEl = event.target;
  const isFormValid = formEl.checkValidity();

  if (!isFormValid) {
    event.preventDefault();
  }

  const firstInvalidInputEl = formEl.querySelector('input:invalid');
  firstInvalidInputEl?.focus();
}

/*
* Initializes javascript validation logic for all address fields on the Account page.
*/
const initJavascriptValidationForForm = async () => {
  const addressForm = await isElementLoaded('.account--address');
  addressForm.dataset.jsEnabled = 'true';

  document.querySelectorAll('form').forEach((form) => {
    form.setAttribute('novalidate', '');
    form.addEventListener('submit', onSubmit);
  });

  document.querySelectorAll('.js-validate').forEach((inputEl) => {
    inputEl.addEventListener('blur', (event) => {
      updateValidationState(event.target);
    });
    // Update the state for prefilled inputs (i.e., on Firefox)
    if (inputEl.value !== '') {
      updateValidationState(inputEl);
    }
  });
}

/*
* Initializes javascript validation logic for Klaviyo sign-up form in the footer.
*/
const initJavascriptValidationForFooterForm = async () => {
  const newsletterFooterForm = await isElementLoaded('#newsletter-footer');
  newsletterFooterForm.dataset.jsEnabled = 'true';

  document.querySelectorAll('form').forEach((form) => {
    form.setAttribute('novalidate', '');
    form.addEventListener('submit', onSubmit);
  });

  document.querySelectorAll('.js-validate').forEach((inputEl) => {
    inputEl.addEventListener('blur', (event) => {
      updateValidationState(event.target);
    });
    // Update the state for prefilled inputs (i.e., on Firefox)
    if (inputEl.value !== '') {
      updateValidationState(inputEl);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  /**
   * Initialize the javascript validation state for all form elements on the account page and in the footer.
   */
  initJavascriptValidationForForm();
  initJavascriptValidationForFooterForm();
});

/**
 * Initialize the javascript validation state and send newsletter signup
 * consent to OneTrust for Klaviyo signup form in the footer
 *
 * @param {Event} - The click event.
 * @returns {Promise} - A success or rejected Promise object.
 */
const newsletterForm = document.querySelector('#newsletter-footer');
const newsletterFormSubmit = document.querySelector('#newsletter-subscribe');

newsletterFormSubmit.addEventListener('click', async (event) => {
  event.preventDefault();
  event.stopPropagation();

  document.querySelectorAll('.js-validate').forEach((inputEl) => {
    if (inputEl.value !== '') {
      updateValidationState(inputEl);
    }
  });

  const isFormValid = newsletterForm.checkValidity();
  // Focus on invalid input if exists, and prevent form submission
  if (!isFormValid) {
    const firstInvalidInputEl = newsletterForm.querySelector('input:invalid');
    firstInvalidInputEl?.focus();
    return;
  } else {
    try {
      const response = await fetch('https://apigeex2.juicyorange.com/epic/register', {
        method: 'POST',
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          email: document.querySelector('#Email').value.toString(),
          subscribe: 'true',
          consent: 'true',
          source_code: 20004
        })
      }).then(response => response.json()).then(data => {
        if (data.UserId) {
          document.cookie = "gmi.profile.id=" + data.UserId + "; path=/; secure=true";
          document.cookie = "gmi.profile.unified.id=" + data.UnifiedId + "; path=/; secure=true";
          document.cookie = "gmi.profile.status=EmailOnly; path=/; secure=true";

          document.querySelector('.newsletter__form-message').classList.toggle('hidden');
          document.querySelector('.newsletter__input').classList.toggle('hidden');
          document.querySelector('#newsletter-email-desc').style.display === 'none';
          document.querySelector('.newsletter-label[for="Email"]').style.display === 'none';
        } else {
          const formElements = form.querySelectorAll('select, option, label, input, aside');
          formElements.forEach(element => {
            element.style.display = 'none';
          });
          klaviyo_popup__alertContainer.forEach((element) => {
            element.style.display = 'none';
          });
          klaivyo_popup__submit.style.display = "none";
          klaivyo_popup__shopNow__wrapper.style.display = "none";
          form.querySelector('h1').textContent = 'There was an issue subscribing. Please try again.';
          form.querySelector('h1').focus();
        }
      })
    } catch (err) {
      console.error(err);
    }
  }
});
